(() => {
  document.addEventListener('click', event => {
    const target = event.target.closest('[data-print-page], [data-cart-drawer-close], [data-mobile-facets-close], [data-select-on-click]');
    if (!target) return;

    if (target.hasAttribute('data-print-page')) {
      window.print();
      return;
    }

    if (target.hasAttribute('data-cart-drawer-close')) {
      target.closest('cart-drawer')?.close();
      return;
    }

    if (target.hasAttribute('data-mobile-facets-close')) {
      target.closest('.mobile-facets__wrapper')?.querySelector('summary')?.click();
      return;
    }

    if (target.hasAttribute('data-select-on-click') && typeof target.select === 'function') {
      target.select();
    }
  });
})();
